// extracted by mini-css-extract-plugin
module.exports = {"ChangePassword":"ChangePassword_ChangePassword__3ySUS","ChangePasswordParent":"ChangePassword_ChangePasswordParent__oLfn1"};